var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBombDefused(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 240.4 209",
    style: {
      enableBackground: "new 0 0 240.4 209"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#338FCE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b94ihL.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.2,43.1c-6.3,2-8.7-2.4-11.5-6.1c-6.9-9.2-13.9-18.3-20.8-27.5c-1.1-1.4-1.9-2.9-2.9-4.4 c0.3-0.5,0.6-1,0.9-1.5c1.7,0.7,3.6,1.1,5.1,2.1c8,5.4,15.6,11.5,23.8,16.5c9,5.5,16.2,12.4,21.6,21.4c2.4,4,6.1,5.9,10.5,7.7 c15.4,6.4,31.1,3.5,46.8,3.1c17.7-0.4,35.7-2.9,52.9,3.5c6,2.2,12,5,17.5,8.3c7.9,4.8,15.5,10.4,23.1,15.7 c3.6,2.5,4.7,6.9,2.7,10.4c-2,3.5-7.2,5.9-10.7,4.2c-4.8-2.3-9.3-5.2-13.8-7.9c-13.6-8-27.9-14.8-43.8-15.4 c-12.2-0.5-24.5,1.4-36.7,2.5c-10,0.9-20,2.6-29.3-2.4c-5-2.7-6.7,1.3-8.5,4c-0.8,1.2-0.1,4.4,1,5.9c5.2,7,10.7,13.7,16.5,20.9 c-1.8-0.5-3.7-1.1-6.1-1.8c1.1,6.1,2.6,11.8,3.2,17.7c2.1,20.6,8.7,39.3,23,54.6c5.3,5.7,11.7,10.3,17.8,15.2 c2.9,2.4,5.2,5,4.1,8.8c-1.1,3.9-2.2,8.2-7.3,9c-1.6,0.2-3.7,0.2-5.1-0.6c-30.1-17.8-49.5-42.8-53-78.6 c-0.9-8.8-1.5-17.6-3.4-26.2c-1.1-4.6-4.4-8.8-7.2-12.9c-4.8-7-9.4-14.1-18.5-16.4c-8-2-14.1-7.2-20.3-12.3 C26.7,53,17.2,45.6,8,37.9c-1.2-1-1.5-3.2-2.2-4.8c1.6-0.1,3.4-0.6,4.7-0.1c12.5,4.6,24.9,9.3,37.2,14.3c1.9,0.8,3,3.4,4.4,5.1 c0.9,1.2,1.8,3.2,2.8,3.3c1.4,0.1,3.5-0.9,4.4-2.1c2.1-2.8,3.8-5.9,5.6-8.9C64.7,44.2,64.5,43.6,64.2,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.8,81.9c3.8,0.6,7.6,1.1,11.3,1.7c-0.1,0.6-0.1,1.3-0.2,1.9c-3.8-0.4-7.6-0.8-11.4-1.2 C111.6,83.5,111.7,82.7,111.8,81.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.4,92.6c-3.7-1.2-7.5-2.4-11.2-3.6c0.3-0.7,0.5-1.5,0.8-2.2c3.7,1.4,7.4,2.7,11,4.1 C118.8,91.4,118.6,92,118.4,92.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.7,98.9c-3.4-1.9-6.8-3.7-10.1-5.6c0.3-0.6,0.6-1.1,0.9-1.7c3.4,1.9,6.7,3.8,10.1,5.7 C114.3,97.9,114,98.4,113.7,98.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBombDefused);
export default __webpack_public_path__ + "static/media/bomb_defused.5cd4cf7ef6b006c76472ad04828b4ef4.svg";
export { ForwardRef as ReactComponent };